import { jsx as o, jsxs as l } from "react/jsx-runtime";
import { c as r } from "../../../clsx-OuTLNxxd.js";
import { I as c } from "../../../icon-BnqXyiyH.js";
import "../icon/iconsList.js";
const _ = "_stepper_1ruwa_29", d = "_horizontal_1ruwa_33", p = "_vertical_1ruwa_38", e = {
  stepper: _,
  horizontal: d,
  vertical: p,
  "step-container": "_step-container_1ruwa_43",
  "step-number": "_step-number_1ruwa_58",
  "is-disabled": "_is-disabled_1ruwa_68",
  "step-label": "_step-label_1ruwa_73",
  "is-done": "_is-done_1ruwa_85",
  "step-connector": "_step-connector_1ruwa_93",
  "dialog-overlay-show": "_dialog-overlay-show_1ruwa_1",
  "dialog-content-show": "_dialog-content-show_1ruwa_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ruwa_1"
};
function b({ steps: i, orientation: n = "vertical", className: t }) {
  return /* @__PURE__ */ o("div", { className: r(t, e.stepper, e[n]), children: i.map((s, a) => /* @__PURE__ */ l("div", { className: e["step-container"], children: [
    s.icon ? /* @__PURE__ */ o(c, { name: s.icon, color: s.iconColor ?? "inherit", size: "2xl" }) : /* @__PURE__ */ o("span", { className: r(e["step-number"], s.isDisabled && e["is-disabled"]), children: a + 1 }),
    /* @__PURE__ */ o(
      "span",
      {
        className: r(
          e["step-label"],
          s.isDone && e["is-done"],
          s.isDisabled && e["is-disabled"]
        ),
        children: s.content
      }
    ),
    a < i.length - 1 && /* @__PURE__ */ o("div", { className: e["step-connector"] })
  ] }, `step-${a + 1}`)) });
}
export {
  b as ProgressSteps
};
